import React from "react";
import styled from "styled-components";

export default styled.section`
    position: relative;
    z-index: 2;
    margin-left: 80px;
    padding: 0;
    display: block;
    width: calc(100% - 80px);
    height: 100vh;
    text-align: center;
`;